<template>
    <div
        class="algolia-listing-mobile-filter"
        v-show="state && state.results"
    >
        <transition
            enter-active-class="algolia-listing-mobile-filter__filter-wrapper--enter-and-leave-active-class"
            enter-class="algolia-listing-mobile-filter__filter-wrapper--enter--and-leave-to-class"
            enter-to-class="algolia-listing-mobile-filter__filter-wrapper--enter-to-and-leave-class"
            leave-active-class="algolia-listing-mobile-filter__filter-wrapper--enter-and-leave-active-class"
            leave-class="algolia-listing-mobile-filter__filter-wrapper--enter-to-and-leave-class"
            leave-to-class="algolia-listing-mobile-filter__filter-wrapper--enter--and-leave-to-class"
        >
            <div
                class="algolia-listing-mobile-filter__filter-wrapper"
                :style="{
                    position: isOpen ? 'fixed' : 'relative'
                }"
            >
                <div
                    class="algolia-listing-mobile-filter__header"
                    v-show="isOpen"
                >
                    <div
                        class="algolia-listing-mobile-filter__header-content-wrapper"
                    >
                        <div
                            class="algolia-listing-mobile-filter__header-title"
                        >
                            {{
                                $t("algoliaSearch.fiterPanelMobileHeaderTitle")
                            }}
                        </div>
                        <p
                            class="algolia-listing-mobile-filter__header-subtext"
                        >
                            {{
                                $t(
                                    "algoliaSearch.fiterPanelMobileHeaderSubtext"
                                )
                            }}
                        </p>
                    </div>

                    <button
                        @click="toggleFilters"
                        class="algolia-listing-mobile-filter__header-button"
                    >
                        <i class="fa fa-times"></i>
                    </button>
                </div>

                <div
                    class="algolia-listing-mobile-filter__body-wrapper"
                    :style="{
                        background: isOpen ? 'white' : 'none'
                    }"
                >
                    <div class="algolia-listing-mobile-filter__body">
                        <div
                            class="algolia-listing-mobile-filter__content-wrapper"
                            v-show="isOpen"
                        >
                            <div class="row w-100">
                                <div class="col-10">
                                    <template
                                        v-for="(filter, index) in filters"
                                    >
                                        <refinement-list
                                            v-if="
                                                filter.filter_type ===
                                                    'refinementList'
                                            "
                                            :key="index"
                                            :attribute="filter.attribute_name"
                                            :label="filter.filter_header"
                                            :limit="filter.limit"
                                            :is-open="true"
                                        />
                                        <refinement-list-slider
                                            v-if="
                                                filter.filter_type ===
                                                    'refinementListSlider'
                                            "
                                            :key="index"
                                            :attribute="filter.attribute_name"
                                            :label="filter.filter_header"
                                            :is-open="true"
                                        />
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div
                            class="algolia-listing-mobile-filter__footer-wrapper"
                        >
                            <div
                                v-if="isOpen"
                                class="algolia-listing-mobile-filter__current-filtered-products"
                            >
                                <ais-clear-refinements>
                                    <template
                                        v-slot="{
                                            canRefine,
                                            refine,
                                            createURL
                                        }"
                                    >
                                        <a
                                            class="algolia-listing-filters__delete-all-button algolia-listing-filters__delete-all-button--mobile"
                                            :href="createURL()"
                                            @click.prevent="refine"
                                            v-if="canRefine"
                                        >
                                            {{
                                                $t(
                                                    "algoliaSearch.fiterPanelMobileDeleteFilters"
                                                )
                                            }}
                                            <svg
                                                width="9"
                                                height="10"
                                                viewBox="0 0 9 10"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M6.20591 5L8.76452 2.26371C9.07849 1.92793 9.07849 1.38352 8.76452 1.04746L8.19588 0.439336C7.8819 0.103555 7.37284 0.103555 7.05861 0.439336L4.5 3.17562L1.94139 0.439336C1.62741 0.103555 1.11835 0.103555 0.804119 0.439336L0.235483 1.04746C-0.0784943 1.38324 -0.0784943 1.92766 0.235483 2.26371L2.79409 5L0.235483 7.73629C-0.0784943 8.07207 -0.0784943 8.61648 0.235483 8.95254L0.804119 9.56066C1.1181 9.89645 1.62741 9.89645 1.94139 9.56066L4.5 6.82438L7.05861 9.56066C7.37259 9.89645 7.8819 9.89645 8.19588 9.56066L8.76452 8.95254C9.07849 8.61676 9.07849 8.07234 8.76452 7.73629L6.20591 5Z"
                                                    fill="#E53F00"
                                                />
                                            </svg>
                                        </a>
                                    </template>
                                </ais-clear-refinements>

                                <ais-current-refinements>
                                    <template
                                        v-slot:item="{
                                            item,
                                            refine,
                                            createURL
                                        }"
                                    >
                                        <div
                                            v-for="refinement in item.refinements"
                                            :key="
                                                [
                                                    refinement.attribute,
                                                    refinement.type,
                                                    refinement.value,
                                                    refinement.operator
                                                ].join(':')
                                            "
                                        >
                                            <a
                                                class="algolia-listing-filters__active-filter-block"
                                                :href="createURL(refinement)"
                                                @click.prevent="
                                                    refine(refinement)
                                                "
                                            >
                                                <span v-if="refinement.attribute === 'combinations.price_reduction'">
                                                    {{ $t('myAccount.appModalListItemLink') }}: {{ refinement.label === '1' ? $t('algoliaSearch.filters.priceReduction.on') : $t('algoliaSearch.filters.priceReduction.off')}}
                                                </span>
                                                <span v-else>{{
                                                    refinement.label
                                                }}</span>

                                                <svg
                                                    width="9"
                                                    height="10"
                                                    viewBox="0 0 9 10"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M6.20591 5L8.76452 2.26371C9.07849 1.92793 9.07849 1.38352 8.76452 1.04746L8.19588 0.439336C7.8819 0.103555 7.37284 0.103555 7.05861 0.439336L4.5 3.17562L1.94139 0.439336C1.62741 0.103555 1.11835 0.103555 0.804119 0.439336L0.235483 1.04746C-0.0784943 1.38324 -0.0784943 1.92766 0.235483 2.26371L2.79409 5L0.235483 7.73629C-0.0784943 8.07207 -0.0784943 8.61648 0.235483 8.95254L0.804119 9.56066C1.1181 9.89645 1.62741 9.89645 1.94139 9.56066L4.5 6.82438L7.05861 9.56066C7.37259 9.89645 7.8819 9.89645 8.19588 9.56066L8.76452 8.95254C9.07849 8.61676 9.07849 8.07234 8.76452 7.73629L6.20591 5Z"
                                                        fill="#757575"
                                                    />
                                                </svg>
                                            </a>
                                        </div>
                                    </template>
                                </ais-current-refinements>
                            </div>
                            <div
                                class="algolia-listing-mobile-filter__bottom-footer-wrapper"
                                v-if="!isApp || isOpen"
                                @click="toggleFilters"
                            >
                                <div
                                    class="algolia-listing-mobile-filter__filtered-product-amount-wrapper"
                                >
                                    <ais-stats
                                        v-if="isOpen"
                                        class="algolia-listing-mobile-filter__filtered-product-amount-text"
                                    >
                                        <template
                                            v-slot="{
                                                hitsPerPage,
                                                nbPages,
                                                nbHits,
                                                page,
                                                processingTimeMS,
                                                query
                                            }"
                                        >
                                            <span
                                                class="algolia-listing-mobile-filter__filtered-product-amount-text--number"
                                                >{{ nbHits }}</span
                                            ><br />{{
                                                $t(
                                                    "algoliaSearch.fiterPanelMobileFilteredProductAmount"
                                                )
                                            }}
                                        </template>
                                    </ais-stats>
                                </div>
                                <div
                                    class="algolia-listing-mobile-filter__footer-text-wrapper"
                                >
                                    <div
                                        v-if="isOpen"
                                        class="algolia-listing-mobile-filter__footer-text"
                                    >
                                        {{
                                            $t(
                                                "algoliaSearch.fiterPanelMobileSaveSelection"
                                            )
                                        }}
                                    </div>
                                    <ais-stats
                                        v-else
                                        class="algolia-listing-mobile-filter__footer-text"
                                    >
                                        <template
                                            v-slot="{
                                                hitsPerPage,
                                                nbPages,
                                                nbHits,
                                                page,
                                                processingTimeMS,
                                                query
                                            }"
                                        >
                                            {{
                                                $t(
                                                    "algoliaSearch.fiterPanelMobileFooterTextPartOne"
                                                )
                                            }}
                                            <span
                                                class="algolia-listing-mobile-filter__footer-text--underline"
                                                >{{ nbHits }}</span
                                            >
                                            {{
                                                $t(
                                                    "algoliaSearch.fiterPanelMobileFooterTextPartTwo"
                                                )
                                            }}
                                        </template>
                                    </ais-stats>
                                </div>
                                <div
                                    class="algolia-listing-mobile-filter__button-wrapper"
                                >
                                    <button
                                        v-if="isOpen"
                                        class="algolia-listing-mobile-filter__icon-button"
                                    >
                                        <i class="fa fa-check"></i>
                                    </button>
                                    <button
                                        v-else
                                        class="algolia-listing-mobile-filter__icon-button"
                                    >
                                        <svg width="40" height="34" viewBox="0 0 40 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_11_456)">
                                                <path d="M37.9902 2.97618H22.0588V1.19048C22.0588 0.535715 21.5073 0 20.8333 0H18.3823C17.7083 0 17.1568 0.535715 17.1568 1.19048V2.97618H1.22549C0.55147 2.97618 0 3.5119 0 4.16667V5.35715C0 6.0119 0.55147 6.54762 1.22549 6.54762H17.1568V8.33333C17.1568 8.9881 17.7083 9.52382 18.3823 9.52382H20.8333C21.5073 9.52382 22.0588 8.9881 22.0588 8.33333V6.54762H37.9902C38.6642 6.54762 39.2157 6.0119 39.2157 5.35715V4.16667C39.2157 3.5119 38.6642 2.97618 37.9902 2.97618ZM37.9902 26.7857H12.2549V25C12.2549 24.3452 11.7034 23.8095 11.0294 23.8095H8.57843C7.90442 23.8095 7.35293 24.3452 7.35293 25V26.7857H1.22549C0.55147 26.7857 0 27.3215 0 27.9762V29.1667C0 29.8215 0.55147 30.3572 1.22549 30.3572H7.35293V32.1428C7.35293 32.7977 7.90442 33.3333 8.57843 33.3333H11.0294C11.7034 33.3333 12.2549 32.7977 12.2549 32.1428V30.3572H37.9902C38.6642 30.3572 39.2157 29.8215 39.2157 29.1667V27.9762C39.2157 27.3215 38.6642 26.7857 37.9902 26.7857ZM37.9902 14.881H31.8627V13.0952C31.8627 12.4405 31.3113 11.9048 30.6373 11.9048H28.1863C27.5123 11.9048 26.9608 12.4405 26.9608 13.0952V14.881H1.22549C0.55147 14.881 0 15.4167 0 16.0714V17.2618C0 17.9167 0.55147 18.4523 1.22549 18.4523H26.9608V20.2382C26.9608 20.8928 27.5123 21.4285 28.1863 21.4285H30.6373C31.3113 21.4285 31.8627 20.8928 31.8627 20.2382V18.4523H37.9902C38.6642 18.4523 39.2157 17.9167 39.2157 17.2618V16.0714C39.2157 15.4167 38.6642 14.881 37.9902 14.881Z" fill="white"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_11_456">
                                                    <rect width="40" height="33.3333" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import RefinementList from "./RefinementList";
import RefinementListSlider from "./RefinementListSlider";
import {
    AisCurrentRefinements,
    AisClearRefinements,
    AisHits,
    AisStats,
    createWidgetMixin
} from "vue-instantsearch/vue3/es";
import { connectHits } from "instantsearch.js/es/connectors";
import { isBrekzApp } from "../../../js/helper/app-helper";

export default {
    name: "FilterPanelMobile",
    components: {
        AisCurrentRefinements,
        AisClearRefinements,
        RefinementListSlider,
        RefinementList,
        AisHits,
        AisStats
    },
    data() {
        return {
            isOpen: false
        };
    },
    props: {
        filters: {
            type: Array,
            required: true
        }
    },
    computed: {
        isApp() {
            return isBrekzApp();
        }
    },
    mounted() {
        window.EventBus.$on("toggle-algolia-filters", () => {
            this.toggleFilters();
        });
    },
    methods: {
        toggleFilters() {
            if (this.isOpen) {
                const AlgoliaResultsElement = document.getElementById('algolia_results')
                AlgoliaResultsElement.scrollIntoView({behavior: "smooth", block: "start"});

                if (this.isApp) {
                    $(".bottom-nav").show();
                }
                this.isOpen = false;
            } else {
                if (this.isApp) {
                    $(".bottom-nav").hide();
                }
                this.isOpen = true;
            }
        }
    },
    mixins: [createWidgetMixin({ connector: connectHits })]
};
</script>
